import { memo } from "react";
import { ContextModalProps } from "@mantine/modals";

import { Button, Group, Stack, Text } from "@mantine/core";

import { useDeleteCustomViewMutation } from "modules/core/hooks/mutations/custom_views/useDeleteCustomViewMutation";

import { CustomView } from "modules/core/types/entities";

type CustomViewModalProps = ContextModalProps<{
  view: CustomView;
  onSubmit?: () => void;
}>;

const CustomViewModal = (props: CustomViewModalProps) => {
  const { id, context, innerProps } = props;

  const { mutate: deleteView, isLoading: isDeleting } =
    useDeleteCustomViewMutation();

  const submitHandler = () => {
    deleteView(
      {
        id: innerProps.view.id
      },
      {
        onSuccess: () => {
          context.closeModal(id);
          innerProps.onSubmit?.();
        }
      }
    );
  };

  return (
    <Stack>
      <Text c="gray.7">
        Are you sure you want to delete <strong>{innerProps.view.title}</strong>{" "}
        view?
      </Text>

      <Group justify="flex-end">
        <Button
          variant="light"
          color="dark"
          size="xs"
          disabled={isDeleting}
          onClick={() => {
            context.closeModal(id);
          }}
        >
          Cancel
        </Button>

        <Button
          color="red"
          type="submit"
          size="xs"
          loading={isDeleting}
          onClick={submitHandler}
        >
          Delete
        </Button>
      </Group>
    </Stack>
  );
};

export default memo(CustomViewModal);
